import "swiper/css";
import "swiper/css/free-mode";

import React from "react";
import { withRouter } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";

import BannerItem from "@components/bannerItem";
import Loading from "@components/loading/index.jsx";

import { PromotionBannerContainer } from "./elements";
import useController from "./useController";

const swiperOptions = {
	spaceBetween: 10,
	slidesPerView: "auto",
	slidesOffsetBefore: 20,
	slidesOffsetAfter: 20,
	lazy: "true",
	breakpoints: {
		1600: {
			slidesOffsetBefore: 50,
			slidesOffsetAfter: 50,
		},
	},
};

const PromotionBanner = (props) => {
	const {
		refs: { bannerStylesRef },
		helpers: { getPromotionLink, getBannerImage },
		state: { isLoading, banners, promotionCount },
		handlers: { handlePromotionClick },
	} = useController(props);

	return (
		<PromotionBannerContainer count={promotionCount}>
			<style
				className="casino-style"
				ref={bannerStylesRef}></style>
			<Loading loading={isLoading} />
			<Swiper {...swiperOptions}>
				<div className="swiper-wrapper">
					{banners.map((banner) => (
						<SwiperSlide
							className={"swiper-slide item promotion-item"}
							onClick={() => handlePromotionClick(banner)}
							key={`home-banner-${banner.title ?? banner?.mobile}`}>
							<BannerItem
								banner={{
									...banner,
									image: getBannerImage(banner),
									link: getPromotionLink(banner),
								}}
							/>
						</SwiperSlide>
					))}
				</div>
			</Swiper>
		</PromotionBannerContainer>
	);
};

export default withRouter(PromotionBanner);
